import React from 'react'

export const Warnings = ({ warnings, item, children }) => {
  return (
    <div>
      <h3 style={{ background: 'orange', color: 'white' }}>
        {item.layoutVariant} is missing fields {warnings.join(',')}
      </h3>
      {children}
    </div>
  )
}
